import React from 'react';
import PropTypes from 'prop-types';
import StarsCounters from './StarsCounters';
import Ranking from './Ranking';

import './style.scss';

const Breakdown = (props) => {
    const { totalCount, starSummary = {}, starsCounters = [] } = props;

    return (
        <div className="breakdown-wrapper grid-12">
            <div className="col-12-xs col-6-sm">
                <StarsCounters list={starsCounters} total={totalCount} />
            </div>
            <div className="col-12-xs col-6-sm">
                <Ranking starSummary={starSummary} />
            </div>
        </div>
    );
};

Breakdown.propTypes = {
    totalCount: PropTypes.number,
    starSummary: PropTypes.object,
    starsCounters: PropTypes.array,
};

export default Breakdown;
